import { TErrorMap } from "../type";

/**
 * SERVER端错误码
 */
export const SERVER_ERROR_MAP: TErrorMap = {
  version: "3.6.16",
  zh_CN: {
    "CHARGE:646": "云会议室已达企业允许呼入的上限",
    "CHARGE:647": "终端已达允许呼入的上限",
    "CHARGE:644": "没有呼叫权限",
    "CHARGE:645": "云会议室已达允许呼入的上限",
    "CHARGE:648": "终端已达企业允许呼入的上限",
    "CHARGE:649": "预约会议未到开始时间，无法加入",
    "PS:400": "不支持跨云呼叫",
    "SIG:421": "对方终端不允许外人拨打，请与对方确认后再拨",
    "SIG:422": "您已被主持人移出会议",
    "SIG:420": "号码不正确",
    "SIG:789": "录制已停止",
    "SIG:423": "UNKONWN",
    "SIG:424": "主持人已结束会议",
    "CHARGE:642": "呼叫失败，企业IPPBX方数已达上限",
    "CHARGE:643": "调度失败，企业监控调度方数已达上限\t",
    "CHARGE:640": "所属部门的云会议室存储空间已满，不能再发起录制",
    "CHARGE:641": "所属企业的云会议室存储空间已满，不能再发起录制",
    "CHARGE:635": "账户余额不足，不能发起PSTN通话，请联系管理员充值后再尝试。",
    "CHARGE:636": "云会议室已达允许呼入的上限",
    "CHARGE:633": "无法呼叫当前号码，您的终端仅允许呼叫通讯录上的用户号码",
    "CHARGE:634":
      "账户余额支付范围不可用于PSTN通话，请联系管理员开启后再尝试。",
    "CHARGE:639": "云会议室存储空间已满，不能再发起录制",
    "CHARGE:637": "云会议室已达部门允许呼入的上限",
    "CHARGE:638": "云会议室已达企业允许呼入的上限",
    "SIG:419": "对方已开启办公模式。您可滑动下方按钮，发起呼叫",
    "SIG:416": "当前在线呼叫数已达服务上限，请稍候再试",
    "SIG:417": "密码输入超时",
    "SIG:410": "呼叫失败，请再试一次",
    "SIG:4445": "云会议室存储空间已满，不能再发起录制",
    "SIG:411": "终端APP版本过低，请升级后再试",
    "SIG:4446": "所属部门的云会议室存储空间已满，不能再发起录制",
    "SIG:4443": "UNKONWN",
    "SIG:4444": "UNKONWN",
    "SIG:414": "密码错误次数达到3次，请稍后重试",
    "SIG:4449": "无效的分享conten类型",
    "SIG:415": "同步呼叫信息失败，请稍后再试",
    "SIG:412": "对方版本过低，通话无法接通",
    "SIG:4447": "所属企业的云会议室存储空间已满，不能再发起录制",
    "SIG:413": "对方设置了免打扰",
    "SIG:4448": "未知错误",
    "SIG:4441": "录制超时，请稍后再试",
    "CHARGE:631":
      "此云会议室为按参会时长计费的会议室。您的账户余额已用尽，不能在此云会议室发起会议，请联系管理员充值或选择其他云会议室。",
    "SIG:4442": "UNKONWN",
    "CHARGE:632": "主动呼叫权限已被管理员关闭，无法发起呼叫",
    "SIG:4440": "分享content超时，请稍后再试",
    "CHARGE:630": "当前云会议室不允许邀请通讯录外成员",
    "CHARGE:624": "呼叫失败。您呼叫的终端端口使用服务已过期",
    "CHARGE:625": "此会议有终端端口服务已过期，无法支持多方呼叫",
    "CHARGE:622": "没有监看权限",
    "REC:511": "录制服务暂时不可用，请稍后再试",
    "CHARGE:623":
      "呼叫失败。终端端口使用服务已过期，不能加入云会议室或多方通话。",
    "REC:512": "录制服务暂时不可用，请稍后再试",
    "CHARGE:628": "您呼叫的云会议室不允许匿名用户呼入，请登录或注册后重新呼叫",
    "CHARGE:629": "对方正在会议中，且该会议不允许通讯录外成员呼入，请稍后再试",
    "CHARGE:626": "此会议有终端端口服务已过期，无法邀请更多人加入",
    "CHARGE:627": "呼叫的云会议室不允许通讯录外成员呼入，请联系云会议室管理员",
    "SIG:1503": "分配监控资源失败",
    "SIG:4456": "连接已断开，请重新入会",
    "SIG:4457": "号码输入有误，请核对后重新拨打！",
    "SIG:441": "当前在线呼叫数已达网关服务上限，请稍候重试",
    "SIG:4454": "通话不存在，请核对后重试",
    "SIG:4455": "服务器未连接，请稍后重试",
    "SIG:445": "UNKONWN",
    "SIG:1501": "shuttle获取MA失败",
    "SIG:4458": "网络异常，呼叫已断开",
    "SIG:1502": "shuttle获取媒体资源失败",
    "SIG:4459": "号码输入有误，请核对后重新拨打！",
    "SIG:4452": "录制失败",
    "CHARGE:620": "无单位归属，不能呼叫H.323设备\t",
    "SIG:440": "云会议室密码不正确，请重试",
    "SIG:4453": "通话已存在，请稍后再试",
    "CHARGE:621": "呼叫失败，单位H.323方数不足",
    "SIG:4450": "不支持分享content",
    "SIG:4451": "带宽不足，分享内容失败",
    "CHARGE:613": "UNKONWN",
    "CHARGE:614": "UNKONWN",
    "REC:400": "信令服务与录制服务内部错误。",
    "CHARGE:611": "UNKONWN",
    "REC:401": "录制服务暂时不可用，请稍后再试",
    "CHARGE:612": "UNKONWN",
    "REC:402": "录制服务暂时不可用，请稍后再试",
    "CHARGE:617": "UNKONWN",
    "REC:403": "录制服务暂时不可用，请稍后再试",
    "CHARGE:618": "UNKONWN",
    "REC:404": "录制不存在",
    "CHARGE:615": "UNKONWN",
    "REC:405": "录制服务暂时不可用，请稍后再试",
    "CHARGE:616": "会议已被锁定，无法加入，请联系会议发起人解锁后进入。",
    "CHARGE:619": "呼叫失败。终端的云服务端口已过期，请联系管理员续费购买。",
    "SIG:432": "UNKONWN",
    "SIG:433": "UNKONWN",
    "SIG:430": "Content发送时会议尚未开始",
    "SIG:431": "Content Server创建资源失败INVALID_PASSWORD",
    "SIG:4466": "输入密码超时",
    "REC:406": "录制服务暂时不可用，请稍后再试",
    "SIG:4460": "号码输入有误，请核对后重新拨打！",
    "CHARGE:610": "呼叫失败，您的企业已禁止PSTN通话功能，请联系您的管理员！",
    "SIG:4461": "号码输入有误，请核对后重新拨打！",
    "SIG:1404": "UNKONWN",
    "SIG:469": "录制正在进行，请勿重复发起录制",
    "CHARGE:441": "当前在线呼叫数已达网关服务上限，请稍候重试",
    "SIG:461": "录制时，本地空间即将耗尽",
    "SIG:462": "录制时，本地空间已耗尽",
    "SIG:580": "pstn呼叫时，第三方服务器报错",
    "REC:465": "本地已开启录制，不能重复发起录制",
    "REC:466": "录制服务暂时不可用，请稍后再试",
    "REC:467": "已达最大录制方数，不能发起录制",
    "REC:468":
      "录制的存储空间已满，您无法开始录制。\n请删除已有的录制视频，\n或联系管理员购买更多存储空间",
    "REC:469": "UNKONWN",
    "REC:460": "没有录制权限",
    "REC:463":
      "录制的存储空间已满，您无法开始录制。\n请删除已有的录制视频，\n或联系管理员购买更多存储空间",
    "SIG:456": "呼叫失败，请再试一次",
    "CHARGE:671": "会议未开始，请等待主持人开始会议后加入",
    "CHARGE:672": "已被移出本次会议，无法入会",
    "CHARGE:670": "您有一场会议正在进行，请先结束该会议",
    "SIG:450": "您的终端目前无法支持此类呼叫",
    "CHARGE:675": "没有可用的视频监控资源",
    "CHARGE:676": "视频监控服务并发超过限制",
    "CHARGE:673": "监控服务已经过期",
    "CCC:501": "数据库操作失败",
    "CHARGE:674": "视频监控服务没有企业归属",
    "CCC:500": "内部服务器错误",
    "CHARGE:668": "会议未通过审批或未到预约开始时间",
    "CCC:602": "输入超时",
    "CHARGE:669": "管理员禁用点对点呼叫",
    "CCC:601": "呼叫超时",
    "CHARGE:666": "超过会议审批允许的最大成员数量，入会失败",
    "CCC:604": "入会超时",
    "CHARGE:667": "超过会议审批允许的最大成员数量，邀请失败",
    "CCC:603": "评价结束",
    "CHARGE:10000": "参会方信息有变，无法参会",
    "SIG:487": "呼叫已取消",
    "SIG:488": "终端试用期已过，无法继续为您服务了",
    "SIG:485": "已达最大呼叫时长，呼叫已断开",
    "SIG:486": "对方忙，请稍后再试",
    "CHARGE:660": "对方企业账户余额不足，不能发起SDK呼叫",
    "SIG:480": "呼叫失败，请再试一次",
    "CHARGE:661": "对方企业账户尚未开通小程序SDK呼叫服务",
    "SIG:483": "拨打不支持国家的pstn号码",
    "CHARGE:664": "PSTN呼叫已达部门允许呼入的上限",
    "SIG:484": "电话时长已用尽，无法转呼手机号，请联系IT管理员及时充值",
    "CHARGE:665": "服务已过期，请管理员更新服务许可证",
    "CHARGE:420": "号码不正确",
    "CHARGE:662": "对方企业账户余额不足，不能发起小程序SDK呼叫",
    "SIG:482": "邀请失败，请重试",
    "CHARGE:415": "服务已过期，请管理员更新服务许可证",
    "CHARGE:657": "企业账户余额不足，不能发起小程序SDK呼叫",
    "CHARGE:416": "当前在线呼叫数已达服务上限，请稍候再试",
    "CHARGE:658": "web客户端达到企业的呼叫方数限制",
    "CHARGE:655": "企业账户余额不足，不能发起SDK呼叫",
    "CHARGE:414": "H.323接入服务已过期",
    "CHARGE:656": "企业账户尚未开通小程序SDK呼叫服务",
    "CHARGE:659": "对方企业账户尚未开通SDK呼叫服务",
    "STATE:200": "成功",
    "SIG:598": "呼叫失败，请再试一次",
    "SIG:599": "信令消息格式无效",
    "SIG:479":
      "共享内容路数已达上限，无法发起更多的共享。请等待其他参会者停止共享后再重试",
    "CHARGE:650": "h.323方数已达云会议室允许呼入的上限",
    "CHARGE:653": "会议不支持更多小程序入会，请使用App入会或联系会议管理员",
    "CHARGE:654": "企业账户尚未开通SDK呼叫服务",
    "CHARGE:651": "h.323方数已达部门允许呼入的上限",
    "CCC:600": "用户已被其他座席服务",
    "CHARGE:652": "预约会议已经过期，无法主动加入",
    "SIG:704": "呼叫失败，请再试一次",
    "SIG:703": "呼叫失败，请再试一次",
    "SIG:708": "没有白板分享权限",
    "SIG:709": "不能合并会议",
    "SIG:706": "没有内容标注权限",
    "SIG:707": "没有双流分享权限",
    "CHARGE:481": "对方不允许陌生人呼叫",
    "CCC:415": "坐席名称已存在",
    "CCC:414": "坐席不存在",
    "CCC:417": "IVR配置已存在",
    "CCC:416": "无效的坐席ID",
    "CCC:419": "无效的IVR配置ID",
    "CCC:418": "IVR配置不存在",
    "SIG:498": "当前网络UDP被禁用，无法通话，请联系网络管理员或切换其他网络",
    "SIG:499": "网络异常，呼叫已断开",
    "SIG:496": "媒体超时",
    "SIG:497": "信令超时",
    "SIG:490": "无应答",
    "CHARGE:473": "当前通话人数已满。如需更多人通话，请使用云会议室。",
    "SIG:491": "",
    "CHARGE:474":
      "当前会议人数已满。请加入通讯录，\n购买更多会议端口，详情请咨询本地经销商。",
    "CHARGE:471": "当前通话人数已满。请使用终端或云会议室召开多方视频会议。",
    "CCC:420": "特服号无效，请重新输入",
    "CHARGE:472": "呼叫无法接通，终端在家最多支持4方通话。",
    "CHARGE:477":
      "您呼叫的会议已达到最大支持人数，请联系管理员购买或使用超大型会议室。",
    "CHARGE:478": "您的服务可用分钟数不足，无法呼叫。",
    "CCC:421": "号码不存在",
    "CHARGE:475":
      "当前会议人数已满，请联系管理员%s%s，\n及时为帐户充值，或购买更多会议端口。",
    "CHARGE:476":
      "您呼叫的会议已达到最大支持人数，请联系管理员购买或使用超大型会议室。",
    "CCC:404": "特服号暂时不可用，请稍后再试",
    "CCC:403": "特服号暂时不可用，请稍后再试",
    "CCC:406": "参数非法",
    "REC:478": "录制中断，网络连接中，请重新发起录制",
    "CHARGE:469": "服务资源使用已达最大值，请稍后重试！",
    "CCC:405": "特服号暂时不可用，请稍后再试",
    "REC:479": "录制中断，服务重启中，请重新发起录制",
    "CCC:408": "企业不存在",
    "CCC:407": "企业已存在",
    "CCC:409": "无效的企业ID",
    "SIG:726": "该号码异常已被限制使用",
    "SIG:727": "呼叫失败，请再试一次",
    "SIG:724": "您已被强制邀请加入新的会议",
    "SIG:725": "呼叫失败，请再试一次",
    "REC:470": "无可用录制服务器，请稍后再试",
    "SIG:722": "设备与配对终端连接断开",
    "SIG:723": "设备与指挥调度服务连接断开",
    "SIG:720": "请稍等，主持人稍后邀请您入会",
    "SIG:721": "会议还未开始，请等待主持人入会",
    "CCC:411": "特服号不存在",
    "CHARGE:467": "已达最大录制方数，不能发起录制",
    "CCC:410": "特服号已存在",
    "CHARGE:464": "录制失败，尚未开通录制服务或服务已过期，请联系管理员购买。",
    "CHARGE:20001": "当前会议室无权限邀请此设备入会",
    "CCC:413": "坐席已存在",
    "CHARGE:20000": "无权限呼叫此设备",
    "CCC:412": "无效的特服号",
    "CHARGE:459":
      "帐户余额不足，无法支持此呼叫。\n请联系管理员%s%s，及时为帐户充值。",
    "CHARGE:457": "终端电话可用分钟数不足，请充值；或联系管理员，加入通讯录。",
    "CHARGE:458":
      "暂不支持呼叫国际电话。请联系管理员加入通讯录；或咨询本地经销商，为您的单位开通后台管理帐户。",
    "SIG:716": "网络异常，呼叫已断开",
    "SIG:713": "Content Server创建资源失败",
    "REC:480": "录制失败，因为该会议室已启用单路录制",
    "SIG:714": "Failed to allocated resources for content sharing.",
    "REC:481": "录制中断，网络连接中，请重新发起录制",
    "SIG:719": "呼叫失败，请再试一次",
    "SIG:717":
      "会议室已超出最高通话时长限制，转为语音通话模式，可联系管理员处理",
    "SIG:718": "语音模式限制已解除",
    "SIG:711": "内容发送时会议尚未开始",
    "SIG:712": "内容发送时会议尚未开始",
    "CHARGE:451": "系统不支持此类型呼叫",
    "CHARGE:452":
      "您的云会议室不支持邀请电话入会，\n请联系管理员加入通讯录；\n或咨询本地经销商，为您的开通帐户。",
    "CHARGE:450": "您的终端目前无法支持此类呼叫",
    "CHARGE:455": "暂不支持呼叫国际电话号码。",
    "CCC:400": "特服号暂时不可用，请稍后再试",
    "CHARGE:453":
      "帐户余额不足，无法支持此呼叫。\n请联系管理员%s%s，及时为帐户充值。",
    "CCC:402": "特服号暂时不可用，请稍后再试",
    "CHARGE:454": "终端电话可用分钟数不足，无法呼叫",
    "CCC:401": "特服号暂时不可用，请稍后再试",
    "CHARGE:602": "当前通话人数已达上限，您无法加入。",
    "CHARGE:723": "已设置用户呼叫隔离",
    "CHARGE:603":
      "您呼叫的会议已达最大支持人数。\n设备加入通讯录，可支持更多方会议。\n如需更多支持请呼叫客服终端号’288288’咨询。",
    "CHARGE:721": "不允许互联网链路呼入",
    "CHARGE:601":
      "会议容量使用现在达到上限，\n无法加入会议。请联系管理员%s%s购买更多会议端口。",
    "CHARGE:722": "已设置硬终端呼叫隔离",
    "CHARGE:606":
      "当前会议人数已超限，30分钟后将自动结束。\n请加入通讯录，可支持更多方会议。",
    "CHARGE:607": "您的服务可用分钟数不足，无法呼叫。",
    "CHARGE:604":
      "终端在家仅支持4方通话，当前通话人数已超限，30分钟后将自动结束。",
    "CHARGE:605": "UNKONWN",
    "SIG:506": "录制服务器内部错误",
    "SIG:504": "呼叫失败，请再试一次",
    "CHARGE:608": "您呼叫的会议已达最大支持人数，请联系IT管理员",
    "SIG:505": "呼叫失败，请再试一次",
    "CHARGE:609":
      "您呼叫的会议已达最大支持人数，请联系IT管理员，购买超大型云会议室。",
    "SIG:502": "呼叫失败，请再试一次",
    "SIG:4999": "分享内容失败",
    "SIG:503": "呼叫失败，请再试一次",
    "CHARGE:720": "该账号已使用\t",
    "CHARGE:712": "该云会议室已被设置为禁止被监看",
    "CHARGE:713": "该终端正在参会的云会议室被设置为禁止被监看",
    "CHARGE:710": "不支持pstn呼叫",
    "CHARGE:711": "呼叫失败，您的企业已禁止PSTN通话功能，请联系您的管理员！",
    "CHARGE:716": "用户不在线，无法参会",
    "CHARGE:717": "当前用户无权限入会",
    "REC:503": "录制服务暂时不可用，请稍后再试",
    "CHARGE:714": "监看权限校验超时，请重试",
    "CHARGE:715": "该号码异常已被限制使用",
    "CHARGE:718": "对方终端不允许拨打",
    "CHARGE:719": "该账号已登录其它终端入会",
    "SURV:580": "监控调度呼叫时，第三方服务报错",
    "REC:505": "录制服务暂时不可用，请稍后再试",
    "REC:506": "直播服务暂时不可用，请稍后再试",
    "REC:507": "录制服务暂时不可用，请稍后再试",
    "REC:509": "录制服务暂时不可用，请稍后再试",
    "CHARGE:701": "企业账户余额不足，无法开启录制。请联系管理员充值后再尝试",
    "CHARGE:702": "个人云会议室不可以用，请选择其他会议室或联系管理员",
    "CHARGE:700":
      "企业账户未开通多路录制计费服务，无法开启录制。请联系客户咨询开通事宜",
    "CHARGE:705": "H323融合服务器容量不足",
    "CHARGE:706": "云会议室已达允许呼入的上限",
    "CHARGE:703": "呼叫所用的H323集群容量不足",
    "CHARGE:704": "H323融合服务器容量不足",
    "SIG:408": "对方没应答，请稍后再试",
    "SIG:405": "对方设备不在线，请稍后重试",
    "CHARGE:707": "云会议室存储空间已满，不能再发起录制",
    "SIG:409": "建立多点呼叫时的内部消息",
    "SIG:400": "通讯失败，请升级到最新版本",
    "SIG:403": "远端网络异常，呼叫已断开",
    "SIG:404": "对方不在线",
    "SIG:401": "加密算法不匹配",
    "SIG:402": "该会议室不允许关闭摄像头，请开启摄像头加入会议",
    "SURV:483": "同步会议信息失败，请重试",
    "SURV:482": "邀请失败，请重试",
  },
  zh_TW: {
    "CHARGE:644": "沒有呼叫權限",
    "CHARGE:649": "預約會議未到開始時間，無法加入",
    "PS:400": "不支持跨雲呼叫",
    "SIG:421": "對方終端不允許外人撥打，請與對方確認後再撥",
    "SIG:422": "您已被主持人移出會議",
    "SIG:420": "號碼不正確",
    "SIG:789": "錄制已停止",
    "SIG:423": "UNKONWN",
    "SIG:424": "主持人已結束會議",
    "CHARGE:642": "呼叫失敗，企業IPPBX方數已達上限",
    "CHARGE:643": "調度失敗，企業監控調度方數已達上限",
    "CHARGE:640": "所屬部門的雲會議室存儲空間已滿，不能再發起錄制",
    "CHARGE:641": "所屬企業的雲會議室存儲空間已滿，不能再發起錄制",
    "CHARGE:635": "賬戶余額不足，不能發起PSTN通話，請聯系管理員充值後再嘗試",
    "CHARGE:636": "雲會議室已達允許呼入的上限",
    "CHARGE:633": "無法呼叫當前號碼,您的終端僅允許呼叫通訊錄上的用戶號碼",
    "CHARGE:634":
      "賬戶余額支付範圍不可用於PSTN通話，請聯系管理員開啟後再嘗試。",
    "CHARGE:639": "雲會議室存儲空間已滿，不能再發起錄制",
    "CHARGE:637": "雲會議室已達部門允許呼入的上限",
    "CHARGE:638": "雲會議室已達企業允許呼入的上限",
    "SIG:419": "對方已開啟辦公模式。您可滑動下方按鈕，發起呼叫",
    "SIG:416": "當前在線呼叫數已達服務上限，請稍後再試",
    "SIG:417": "密碼輸入超時",
    "SIG:410": "呼叫失敗，請再試壹次",
    "SIG:4445": "雲會議室存儲空間已滿，不能再發起錄制",
    "SIG:411": "終端APP版本過低，請升級後再試",
    "SIG:4446": "所屬部門的雲會議室存儲空間已滿，不能再發起錄制",
    "SIG:4443": "UNKONWN",
    "SIG:4444": "UNKONWN",
    "SIG:414": " 密碼錯誤次數達到3次，請稍後重試",
    "SIG:4449": "無效的分享content類型",
    "SIG:415": "同步呼叫信息失敗，請稍後再試",
    "SIG:412": "對方版本過低，通話無法接通",
    "SIG:4447": "所屬企業的雲會議室存儲空間已滿，不能再發起錄制",
    "SIG:413": "對方設置了免打擾",
    "SIG:4448": "未知錯誤",
    "CHARGE:631":
      "此雲會議室為按參會時長計費的會議室。您的帳戶餘額已用盡，不能在此雲會議室發起會議，請聯系管理員充值或選擇其他雲會議室。",
    "SIG:4441": "錄制超時，請稍後再試",
    "CHARGE:632": "主動呼叫權限已被管理員關閉,無法呼叫",
    "SIG:4442": "UNKONWN",
    "CHARGE:630": "當前雲會議室不允許邀請通訊錄外成員",
    "SIG:4440": "分享content超時，請稍後再試",
    "CHARGE:624": "呼叫失敗。您呼叫的終端埠使用服務已過期。",
    "CHARGE:625": "此會議有終端端口服務已過期，無法支持多方呼叫",
    "CHARGE:622": "沒有監看權限",
    "CHARGE:623": "呼叫失敗。終端埠使用服務已過期，不能加入雲會議室或多方通話",
    "REC:511": "錄制服務暫時不可用，請稍後再試",
    "CHARGE:628":
      "您呼叫的雲會議室不允許匿名使用者呼入，請登錄或註冊後重新呼叫",
    "REC:512": "錄制服務暫時不可用，請稍後再試",
    "CHARGE:629": "對方正在會議中，且該會議不允許通訊錄外成員呼入，請稍後再試",
    "CHARGE:626": "此會議有終端端口服務已過期，無法邀請更多人加入",
    "CHARGE:627": "呼叫的雲會議室不允許通訊錄外成員呼入，請聯系雲會議室管理員",
    "SIG:1503": "分配監控資源失敗",
    "SIG:4456": "連接已斷開，請重新入會",
    "SIG:4457": "號碼輸入有誤，請核對後重新撥打！",
    "SIG:441": "當前在線呼叫數已達網關服務上限，請稍後重試",
    "SIG:4454": "通話不存在，請核對後重試",
    "SIG:4455": "服務器未連接，請稍後重試",
    "SIG:445": "UNKONWN",
    "SIG:1501": "shuttle獲取MA失敗",
    "SIG:4458": "網絡異常，呼叫已斷開",
    "SIG:1502": "shuttle獲取媒體資源失敗",
    "SIG:4459": "號碼輸入有誤，請核對後重新撥打！",
    "CHARGE:620": "無單位歸屬，不能呼叫H.323設備",
    "SIG:4452": "錄制失敗",
    "CHARGE:621": "呼叫失敗，單位H.323方數不足",
    "SIG:440": "雲會議室密碼不正確，請重試",
    "SIG:4453": "通話已存在，請稍後再試",
    "SIG:4450": "不支持分享content",
    "SIG:4451": "帶寬不足，分享內容失敗",
    "CHARGE:613": "UNKONWN",
    "CHARGE:614": "UNKONWN",
    "CHARGE:611": "UNKONWN",
    "REC:400": "信令服務與錄製服務內部錯誤。",
    "CHARGE:612": "UNKONWN",
    "REC:401": "錄制服務暫時不可用，請稍後再試",
    "CHARGE:617": "UNKONWN",
    "REC:402": "錄制服務暫時不可用，請稍後再試",
    "CHARGE:618": "UNKONWN",
    "REC:403": "錄制服務暫時不可用，請稍後再試",
    "CHARGE:615": "UNKONWN",
    "REC:404": "录制不存在",
    "CHARGE:616": "會議已被鎖定，無法加入，請聯系會議發起人解鎖後進入。",
    "REC:405": "錄制服務暫時不可用，請稍後再試",
    "CHARGE:619": "呼叫失敗。終端的雲服務端口已過期，請聯系管理員續費購買。",
    "SIG:432": "UNKONWN",
    "SIG:433": "UNKONWN",
    "SIG:430": "Content發送時會議尚未開始",
    "SIG:431": "Content Server創建資源失敗",
    "SIG:4466": "輸入密碼超時",
    "REC:406": "錄制服務暫時不可用，請稍後再試",
    "SIG:4460": "號碼輸入有誤，請核對後重新撥打！",
    "CHARGE:610":
      "呼叫失敗，您的企業已禁止PSTN通話功能，請聯系您的企業管理員！",
    "SIG:4461": "號碼輸入有誤，請核對後重新撥打！",
    "SIG:1404": "UNKONWN",
    "SIG:469": "錄製正在進行，請勿重複發起錄製",
    "CHARGE:441": "當前在線呼叫數已達網關服務上限，請稍後重試",
    "SIG:461": "錄制時，本地空間即將耗盡",
    "SIG:462": "錄制時，本地空間已耗盡",
    "SIG:580": "pstn呼叫時，第三方服務器報錯",
    "REC:465": "本地已開啟錄制，不能重復發起錄制",
    "REC:466": "錄制服務暫時不可用，請稍後再試!",
    "REC:467": "已達最大錄制方數，不能發起錄制",
    "REC:468":
      "錄制的存儲空間已滿，您無法開始錄制。\n請刪除已有的錄制視頻，\n或聯系企業管理員購買更多存儲空間。",
    "REC:469": "UNKONWN",
    "REC:460": "沒有錄製權限",
    "REC:463":
      "錄制的存儲空間已滿，您無法開始錄制。\n請刪除已有的錄制視頻，\n或聯系企業管理員購買更多存儲空間。",
    "SIG:456": "呼叫失敗，請再試壹次",
    "CHARGE:671": "會議未開始，請等待主持人開始會議後加入",
    "CHARGE:672": "已被移出本次會議，無法入會",
    "CHARGE:670": "您有一場會議正在進行，請先結束該會議",
    "CHARGE:675": "沒有可用的視頻監控資源",
    "SIG:450": "您的終端目前無法支持此類呼叫",
    "CHARGE:676": "視頻監控服務併發超過限制",
    "CCC:501": "數據庫操作失敗",
    "CHARGE:673": "監控服務已經過期",
    "CCC:500": "內部服務器錯誤",
    "CHARGE:674": "視頻監控服務沒有企業歸屬",
    "CCC:602": "输入超时",
    "CHARGE:668": "會議未通過審批或未到預約開始時間",
    "CCC:601": "呼叫超時",
    "CHARGE:669": "管理員禁用點對點呼叫",
    "CCC:604": "入會超時",
    "CHARGE:666": "超過會議審批允許的最大成員數量，入會失敗",
    "CCC:603": "评价结束",
    "CHARGE:667": "超過會議審批允許的最大成員數量，邀請失敗",
    "CHARGE:10000": "參會方信息有變，無法參會",
    "SIG:487": "呼叫已取消",
    "SIG:488": "終端試用期已過，無法繼續為您服務了",
    "SIG:485": "已達最大呼叫時長，呼叫已斷開",
    "SIG:486": "對方忙，請稍後再試",
    "CHARGE:660": "對方企業帳戶餘額不足，不能發起SDK呼叫",
    "CHARGE:661": "對方企業賬戶尚未開通小程序SDK呼叫服務",
    "SIG:480": "呼叫失敗，請再試壹次",
    "CHARGE:664": "PSTN呼叫已達部門允許呼入的上限",
    "SIG:483": "撥打不支持國家的pstn號碼",
    "CHARGE:665": "小魚易連服務已過期，請企業管理員更新服務許可證",
    "SIG:484": "電話時長已用盡，無法轉呼手機號，請聯繫IT管理員及時充值",
    "CHARGE:420": "號碼不正確",
    "CHARGE:662": "對方企業帳戶餘額不足，不能發起小程序SDK呼叫",
    "SIG:482": "邀請失敗，請重試",
    "CHARGE:415": "小魚易連服務已過期，請企業管理員更新服務許可證",
    "CHARGE:657": "企業帳戶餘額不足，不能發起小程序SDK呼叫",
    "CHARGE:416": "當前在線呼叫數已達服務上限，請稍後再試",
    "CHARGE:658": "web用戶端達到企業的呼叫方數限制",
    "CHARGE:655": "企業帳戶餘額不足，不能發起SDK呼叫",
    "CHARGE:414": "H.323接入服務已過期",
    "CHARGE:656": "企業帳戶尚未開通小程序SDK呼叫服務",
    "CHARGE:659": "對方企業帳戶尚未開通SDK呼叫服務",
    "STATE:200": "成功",
    "SIG:598": "呼叫失敗，請再試壹次",
    "SIG:599": "信令訊息格式無效",
    "SIG:479":
      "共享內容路數已達上限，無法發起更多的共享。請等待其他參會者停止共享后再重試。",
    "CHARGE:650": "h.323方數已達雲會議室允許呼入的上限",
    "CHARGE:653": "會議不支持更多小程序入會，請使用App入會或聯系會議管理員",
    "CHARGE:654": "企業帳戶尚未開通SDK呼叫服務",
    "CCC:600": "用戶已被其他座席服務",
    "CHARGE:651": "h.323方數已達部門允許呼入的上限",
    "CHARGE:652": "預約會議已經過期，無法主動加入",
    "SIG:704": "呼叫失敗，請再試壹次",
    "SIG:703": "呼叫失敗，請再試壹次",
    "SIG:708": "沒有白板分享權限",
    "SIG:709": "無法合併會議",
    "SIG:706": "沒有內容標記權限\t",
    "SIG:707": "沒有雙流分享權限",
    "CHARGE:481": "終端不允許陌生人呼叫",
    "CCC:415": "坐席名稱已存在",
    "CCC:414": "坐席不存在",
    "CCC:417": "IVR配置已存在",
    "CCC:416": "無效的坐席ID",
    "CCC:419": "無效的IVR配置ID",
    "CCC:418": "IVR配置不存在",
    "SIG:498": "當前網絡UDP被禁用，無法通話，\n請聯系網絡管理員或切換其他網絡",
    "SIG:499": "網絡異常，呼叫已斷開",
    "SIG:496": "媒體超時",
    "SIG:497": "信令超時",
    "CHARGE:473":
      "當前通話人數已滿。如需更多人通話，請使用雲會議室。手機端下載小魚易連app，註冊即可獲得。",
    "SIG:490": "無應答",
    "CHARGE:474":
      "當前會議人數已滿，請加入企業通訊錄，\n購買更多會議端口，詳情請咨詢本地經銷商。",
    "SIG:491": "",
    "CCC:420": "特服號暫時不可用，請稍後再試",
    "CHARGE:471": "當前通話人數已滿。請使用終端或雲會議室召開多方視頻會議。",
    "CHARGE:472": "呼叫無法接通，終端在家最多支持4方通話。",
    "CHARGE:477":
      "您呼叫的會議已達到最大支持人數，請聯系管理員購買或使用超大型會議室。",
    "CCC:421": "號码不存在",
    "CHARGE:478": "您的服務可用分鐘數不足，無法呼叫。",
    "CHARGE:475":
      "當前會議人數已滿，請聯系企業管理員%s%s，\n及時為企業帳戶充值，或購買更多會議端口。",
    "CHARGE:476":
      "您呼叫的會議已達到最大支持人數，請聯系管理員購買或使用超大型會議室。",
    "CCC:404": "特服號暫時不可用，請稍後再試",
    "CCC:403": "特服號暫時不可用，請稍後再試",
    "CCC:406": "參數非法",
    "CCC:405": "特服號暫時不可用，請稍後再試",
    "CHARGE:469": "服務資源使用已達最大值，請稍後重試！",
    "REC:478": "錄制中斷，網絡連接中，請重新發起錄制",
    "CCC:408": "企業不存在",
    "REC:479": "錄製中斷，服務重啟中，請重新發起錄製",
    "CCC:407": "企業已存在",
    "CCC:409": "無效的企業ID",
    "SIG:726": "該號碼異常已被限製使用",
    "SIG:727": "呼叫失敗，請再試壹次",
    "SIG:724": "您已被強制邀請加入新的會議",
    "REC:470": "沒有可用的錄製伺服器,請稍後再試",
    "SIG:725": "呼叫失敗，請再試壹次",
    "SIG:722": "設備與配對終端連接斷開",
    "SIG:723": "設備與指揮調度服務連接斷開",
    "SIG:720": "請稍等，主持人稍後邀請您入會",
    "SIG:721": "會議還未開始，請等待主持人入會",
    "CCC:411": "特服號不存在",
    "CCC:410": "特服號已存在",
    "CHARGE:467": "已達最大錄制方數，不能發起錄制",
    "CCC:413": "坐席已存在",
    "CHARGE:464": "錄制失敗，尚未開通錄制服務或服務已過期，請聯系管理員購買。",
    "CHARGE:20001": "當前會議室無許可權邀請此設備入會",
    "CCC:412": "無效的特服號",
    "CHARGE:20000": "無權限呼叫此設備",
    "CHARGE:459":
      "企業帳戶余額不足，無法支持此呼叫。\n請聯系企業管理員%s%s，及時為企業帳戶充值。",
    "CHARGE:457":
      "終端電話可用分鐘數不足，請充值；或聯系企業管理員，加入企業通訊錄。",
    "CHARGE:458":
      "暫不支持呼叫國際電話。請聯系企業管理員加入企業通訊錄；或咨詢本地經銷商，為您開通企業帳戶。",
    "SIG:716": "網絡異常，呼叫已斷開",
    "REC:480": "錄製失敗，因為該會議室已啟用單路錄製模式",
    "SIG:713": "Content Server創建資源失敗",
    "REC:481": "錄制中斷，網絡連接中，請重新發起錄制",
    "SIG:714": "Content Server創建資源失敗",
    "SIG:719": "呼叫失敗，請再試壹次",
    "SIG:717":
      "會議室已超出最高通話時長限制，轉為語音通話模式，可聯繫管理員處理",
    "SIG:718": "語音模式限制已解除",
    "SIG:711": "内容發送時會議尚未開始",
    "SIG:712": "内容發送時會議尚未開始",
    "CHARGE:451": "系統不支持此類型呼叫",
    "CHARGE:452":
      "您的雲會議室不支持邀請電話入會，\n請聯系企業管理員加入企業通訊錄；\n或咨詢本地經銷商，為您的企業開通企業帳戶。",
    "CHARGE:450": "您的終端目前無法支持此類呼叫",
    "CCC:400": "特服號暫時不可用，請稍後再試",
    "CHARGE:455": "暫不支持呼叫國際電話號碼。",
    "CCC:402": "特服號暫時不可用，請稍後再試",
    "CHARGE:453":
      "企業帳戶余額不足，無法支持此呼叫。\n請聯系企業管理員%s%s，及時為企業帳戶充值。",
    "CCC:401": "特服號暫時不可用，請稍後再試",
    "CHARGE:454": "終端電話可用分鐘數不足，無法呼叫。",
    "CHARGE:602": "當前通話人數已達上限，您無法加入。",
    "CHARGE:723": "已設置啟用戶呼叫隔離",
    "CHARGE:603":
      "您呼叫的會議已達最大支持人數。\n設備加入企業通訊錄，可支持更多方會議。\n如需更多支持請呼叫客服終端號’288288’咨詢。",
    "CHARGE:721": "不允許互聯網鏈路呼入！",
    "CHARGE:601":
      "企業會議容量使用現在達到上限，\n無法加入會議。請聯系管理員%s%s購買更多會議端口。",
    "CHARGE:722": "已設置啟硬終端呼叫隔離",
    "CHARGE:606":
      "當前會議人數已超限，30分鐘後將自動結束。\n請加入企業通訊錄，可支持更多方會議。",
    "CHARGE:607": "您的服務可用分鐘數不足，無法呼叫。",
    "CHARGE:604":
      "終端在家僅支持4方通話，當前通話人數已超限，30分鐘後將自動結束",
    "CHARGE:605": "UNKONWN",
    "SIG:506": "錄製伺服器內部錯誤",
    "CHARGE:608": "您呼叫的會議已達最大支持人數，請聯系企業IT管理員",
    "SIG:504": "呼叫失敗，請再試壹次",
    "CHARGE:609":
      "您呼叫的會議已達最大支持人數，請聯系企業IT管理員，購買超大型雲會議室。",
    "SIG:505": "呼叫失敗，請再試壹次",
    "SIG:502": "呼叫失敗，請再試壹次",
    "SIG:4999": "分享內容失敗",
    "SIG:503": "呼叫失敗，請再試壹次",
    "CHARGE:720": "該賬號已使用",
    "CHARGE:712":
      "該雲該雲會議室已被設置為禁止被監看會議室已被設置為禁止被監看",
    "CHARGE:713": "該終端正在參會的雲會議室被設置為禁止被監看",
    "CHARGE:710": "不支持pstn外呼",
    "CHARGE:711":
      "呼叫失敗，您的企業已禁止PSTN通話功能，請聯系您的企業管理員！",
    "CHARGE:716": "當前用戶不在線，無法參會",
    "CHARGE:717": "當前用戶無權限入會",
    "CHARGE:714": "監看權限校驗超時，請重試",
    "REC:503": "錄制服務暫時不可用，請稍後再試",
    "CHARGE:715": "該號碼異常已被限製使用",
    "CHARGE:718": "對方終端不允許撥打",
    "CHARGE:719": "該賬號已登錄其它終端入會",
    "SURV:580": "監控調度呼叫時，第三方服務報錯",
    "REC:505": "錄制服務暫時不可用，請稍後再試",
    "REC:506": "直播服務暫時不可用，請稍後再試",
    "REC:507": "錄制服務暫時不可用，請稍後再試",
    "REC:509": "錄制服務暫時不可用，請稍後再試",
    "CHARGE:701": "企業帳戶餘額不足，無法開啟錄製。請聯系管理員充值後再嘗試",
    "CHARGE:702": "個人云會議室不可以用，請選擇其他會議室或聯繫管理員",
    "CHARGE:700":
      "企業帳戶未開通多路錄製計費服務，無法開啟錄製。請聯系客戶諮詢開通事宜",
    "CHARGE:705": "H323融合服務器容量不足",
    "CHARGE:703": "呼叫所用的H323集群容量不足",
    "CHARGE:704": "H323融合服務器容量不足",
    "SIG:408": "對方沒應答，請稍後再試",
    "SIG:405": "對方設備不在線，請稍後重試",
    "SIG:409": "建立多點呼叫時的內部消息",
    "SIG:400": "通訊失敗，請升級到最新版本",
    "SIG:403": "遠端網絡異常，呼叫已斷開",
    "SIG:404": "對方不在線",
    "SIG:401": "加密算法不匹配",
    "SIG:402": "該會議室不允許關閉攝像頭，請開啟攝像頭加入會議",
    "SURV:483": "同步會議信息失敗，請重試",
    "SURV:482": "邀請失敗，請重試",
  },
  en_US: {
    "CHARGE:646":
      "Cloud meeting has reached the upper limit of organization's allowed incoming calls",
    "CHARGE:647":
      "Terminal has reached the upper limit of allowed incoming calls",
    "CHARGE:644": "No authority",
    "CHARGE:645":
      "Cloud meeting has reached the upper limit of allowed incoming calls",
    "CHARGE:648":
      "Terminal has reached the upper limit of organization's allowed incoming calls",
    "CHARGE:649": "The scheduled meeting is not reached and cannot be joined",
    "PS:400": "Cross-cloud calls are not supported",
    "SIG:421": "Far end does not accept calls by Xiaoyu ID. Please check.",
    "SIG:422": "You are kicked out by chairman.",
    "SIG:420": "Invalid Number.",
    "SIG:789": "Recording has been stopped",
    "SIG:423": "UNKONWN",
    "SIG:424": "The meeting has ended.",
    "CHARGE:642":
      "The call failed, and the IPPBX number of the enterprise has reached the upper limit.",
    "CHARGE:643":
      "Scheduling failed, the number of enterprises monitoring and dispatching reached the upper limit",
    "CHARGE:640":
      "Cloud storage of department is full and can no longer record",
    "CHARGE:641":
      "Cloud storage of organization is full and can no longer record",
    "CHARGE:635":
      "Account balance exhausted, you cannot initiate PSTN calls, please contact the administrator to recharge and then try again.",
    "CHARGE:636":
      "Cloud meeting has reached the upper limit of allowed incoming calls",
    "CHARGE:633":
      "The number can not be dialed out. The endpoint is only authorized to call the number on the contact list",
    "CHARGE:634":
      "Account balance Payment scope is not available for PSTN calls, please contact the administrator to open and then try again.",
    "CHARGE:639": "Cloud storage of user is full and can no longer record",
    "CHARGE:637":
      "Cloud meeting has reached the upper limit of department's allowed incoming calls",
    "CHARGE:638":
      "Cloud meeting has reached the upper limit of organization's allowed incoming calls",
    "SIG:419": "Far end has turned on office mode. Please slide to call.",
    "SIG:416":
      "Current calls have reached the max limit, please try again later.",
    "SIG:417": "Password entry timeout.",
    "SIG:410": "Call is not connected. Please retry.",
    "SIG:4445": "Cloud storage of user is full and can no longer record",
    "SIG:411": "version is too old.",
    "SIG:4446": "Cloud storage of department is full and can no longer record",
    "SIG:4443": "UNKONWN",
    "SIG:4444": "UNKONWN",
    "SIG:414": "Password error number reached 3 times, please try again later.",
    "SIG:4449": "The type of sharing content is invalid.",
    "SIG:415":
      "Synchronization call information failed. Please try again later.",
    "SIG:412": "version is too old.",
    "SIG:4447":
      "Cloud storage of organization is full and can no longer record",
    "SIG:413": "Far end is in Do Not Disturb mode.",
    "SIG:4448": "Unknown error.",
    "SIG:4441": "Record is time out. Please retry later.",
    "CHARGE:631":
      "This meeting room is charged by the minutes of the attendees. While your account balance has been exhausted, you cannot initiate a meeting in this meeting room, please contact your administrator to recharge or select another cloud meeting room.",
    "SIG:4442": "UNKONWN",
    "CHARGE:632": "The endpoint is not authorized to dial out by admin.",
    "SIG:4440": "Sharing content is time out. Please retry later.",
    "CHARGE:630":
      "The current meeting does not allow non-address book members to call in.",
    "CHARGE:624":
      "Call failed. The port service of the terminal you called has expired.",
    "CHARGE:625":
      "This conference port service has expired and cannot support multi-party calls.",
    "CHARGE:622": "No monitoring permission",
    "CHARGE:623":
      "Call failed. The port service of this terminal has expired, and you cannot use this terminal to join cloud meeting room or multiparty call.",
    "REC:511":
      "Xiaoyu recording service is not available, please try again later",
    "CHARGE:628":
      "The meeting ID you called does not allow anonymous users to call in, Please log in or register and call again.",
    "REC:512":
      "Xiaoyu recording service is not available, please try again later",
    "CHARGE:629":
      "Far end is in the meeting which does not allow non-address book members to call in，please retry later.",
    "CHARGE:626":
      "This conference port service has expired, and no more people can be invited.",
    "CHARGE:627":
      "The meeting ID you called does not allow non-address book members to call in, please contact the administrator of the meeting room.",
    "SIG:1503": "Allocating resource for survelliance failed.",
    "SIG:4456":
      "The network is disconnected, please try joining the meeting again.",
    "SIG:4457": "Wrong number, please check it and retry.",
    "SIG:441":
      "Current calls have reached the max limit of gateway, please try again later.",
    "SIG:4454": "No related call, please check and retry later.",
    "SIG:4455": "No connection with server, please retry later.",
    "SIG:445": "UNKONWN",
    "SIG:1501": "shuttle Get MA failed",
    "SIG:4458": "Network unstable, call disconnected.",
    "SIG:1502": "shuttle Get media resource failed",
    "SIG:4459": "Wrong number, please check it and retry.",
    "SIG:4452": "Record failed.",
    "CHARGE:620":
      "You don't belong to an organization,and you cannot call H.323 device",
    "SIG:440": "The password of conference is wrong. Please retry.",
    "SIG:4453": "Call exists, please retry later.",
    "CHARGE:621": "Call failed, insufficient H.323 port of your organization",
    "SIG:4450": "Sharing content is unsupported.",
    "SIG:4451": "Sharing content failed for no bandwidth.",
    "CHARGE:613": "UNKONWN",
    "CHARGE:614": "UNKONWN",
    "CHARGE:611": "UNKONWN",
    "REC:400": "Internal errors in signaling and recording services.",
    "CHARGE:612": "UNKONWN",
    "REC:401":
      "Xiaoyu recording service is not available, please try again later",
    "CHARGE:617": "UNKONWN",
    "REC:402":
      "Xiaoyu recording service is not available, please try again later",
    "CHARGE:618": "UNKONWN",
    "REC:403":
      "Xiaoyu recording service is not available, please try again later",
    "CHARGE:615": "UNKONWN",
    "REC:404": "Record is not found.",
    "CHARGE:616":
      "The meeting is locked, failed to join. Please contact meeting originator to unlock and join.",
    "REC:405":
      "Xiaoyu recording service is not available, please try again later",
    "CHARGE:619":
      "Call failed. The video service of the terminal has expired, please contact IT Admin to renew.",
    "SIG:432": "UNKONWN",
    "SIG:433": "UNKONWN",
    "SIG:430": "Content cannot be shared before meeting is started.",
    "SIG:431": "Failed to allocated resources for content sharing.",
    "SIG:4466": "Check password timeout",
    "REC:406":
      "Xiaoyu recording service is not available, please try again later",
    "SIG:4460": "Wrong number, please check it and retry.",
    "CHARGE:610":
      "Call failed. PSTN call is disabled, please contact your enterprise admin!",
    "SIG:4461": "Wrong number, please check it and retry.",
    "SIG:1404": "UNKONWN",
    "SIG:469": "Recording is in progress, do not repeat the recording",
    "CHARGE:441":
      "Current calls have reached the max limit of gateway, please try again later.",
    "SIG:461": "Local storage will be used up soon.",
    "SIG:462": "Local storage is used up.",
    "SIG:580": "Failed to make PSTN call.",
    "REC:465": "Record is started. Not allow repeated record.",
    "REC:466":
      "Xiaoyu recording service is not available, please try again later.",
    "REC:467":
      "The maximum number of recordings has been reached and you cannot start recording",
    "REC:468": "Storage space not available, cannot .",
    "REC:469": "UNKONWN",
    "REC:460": "You don't have recording permission.",
    "REC:463": "Storage space not available, cannot .",
    "SIG:456": "Call is not connected. Please retry.",
    "CHARGE:671":
      "The meeting did not start，please wait for the host to start the meeting",
    "CHARGE:672": "Has been removed from this meeting and cannot join",
    "CHARGE:670":
      "You have a meeting in progress, please end the meeting first",
    "SIG:450": "Your device does not support this type of call.",
    "CHARGE:675": "No video surveillance service available",
    "CHARGE:676": "Video surveillance service exceeds limit",
    "CCC:501": "Database operate error",
    "CHARGE:673": "The video surveillance service has expired",
    "CCC:500": "Internal server error",
    "CHARGE:674": "Video surveillance services lack enterprise ownership",
    "CHARGE:668":
      "The meeting has not been approved or the scheduled start time  is not reached and cannot be joined",
    "CHARGE:669": "P2P call prohibited by administrator",
    "CHARGE:666":
      "The maximum number of participants approved by the meeting has been exceeded\t",
    "CHARGE:667":
      "The maximum number of participants approved by the meeting has been exceeded",
    "CHARGE:10000":
      "Participant information has been changed, unable to join the meeting.",
    "SIG:487": "Call is canceled.",
    "SIG:488": "The trial has expired. Xiaoyu stops service.",
    "SIG:485": "Reach max duration. Call ended",
    "SIG:486": "Far end busy. Please retry later.",
    "CHARGE:660":
      "The other enterprise account balance is insufficient to initiate SDK calls",
    "SIG:480": "Call is not connected. Please retry.",
    "CHARGE:661":
      "The other enterprise account has not yet enabled  mini-program SDK call service",
    "SIG:483": "PSTN call in this region is not supported.",
    "CHARGE:664":
      "PSTN calling has reached the upper limit of department's allowed incoming calls",
    "SIG:484":
      "Telephone minutes exhausted, you cannnot transfer your mobile phone number. Please contact the IT administrator to recharge in time",
    "CHARGE:665": "Xiaoyu service is expired. Please update your license key.",
    "CHARGE:420": "Incorrect Number.",
    "CHARGE:662":
      "The other enterprise account balance is insufficient to initiate mini-program SDK calls",
    "SIG:482": "The invitation failed, please try again",
    "CHARGE:415": "Xiaoyu service is expired. Please update your license key.",
    "CHARGE:657":
      "The enterprise account balance is insufficient to initiate mini-program SDK calls",
    "CHARGE:416":
      "Current calls have reached the max limit, please try again later.",
    "CHARGE:658":
      "Web client has reached the upper limit of organization's allowed incoming calls",
    "CHARGE:655":
      "The enterprise account balance is insufficient to initiate SDK calls",
    "CHARGE:414": "H.323 access service has expired",
    "CHARGE:656":
      "The enterprise account has not yet enabled  mini-program SDK call service",
    "CHARGE:659":
      "The other enterprise account has not yet enabled  SDK call service",
    "STATE:200": "成功",
    "SIG:598": "Call is not connected. Please retry.",
    "SIG:599": "Signaling message format is not valid.",
    "SIG:479":
      "The number of content share has exceeded the max limit, please retry after other participants stop the content share.",
    "CHARGE:650":
      "The number of h.323 parties has reached the upper limit of the cloud conference room",
    "CHARGE:653":
      "The meeting you are calling does not support the mini-program call-in service , please use app to join the meeting or contact the conference administrator",
    "CHARGE:654":
      "The enterprise account has not yet enabled  SDK call service",
    "CHARGE:651":
      "The number of h.323 parties has reached the upper limit of department's allowed incoming calls",
    "CHARGE:652": "The scheduled meeting has expired and cannot be joined",
    "SIG:704": "Call is not connected. Please retry.",
    "SIG:703": "Call is not connected. Please retry.",
    "SIG:708": "You don't have whiteboard sharing permission.",
    "SIG:709": "Meetings cannot be merged",
    "SIG:706": "You don't have content labeling permission",
    "SIG:707": "You don't have dual-stream sharing permissions",
    "CHARGE:481": "You are not allowed to call this Xiaoyu.",
    "CCC:415": "Same seat name is exist",
    "CCC:414": "Seat is not exist",
    "CCC:417": "IVR config is already exist",
    "CCC:416": "Seat id is invalid",
    "CCC:419": "IVR config id is invalid",
    "CCC:418": "IVR config is not exist",
    "SIG:498":
      "UDP is blocked by the network. Please call administrator or switch to another network.",
    "SIG:499": "Network unstable, call disconnected.",
    "SIG:496": "Media Timeout",
    "SIG:497": "Signal Timeout",
    "SIG:490": "Far end did not answer.MEDIA_TIMEOUT",
    "CHARGE:473":
      "Current session is full. Please use cloud meeting room to have more people in the same conference. \nDownload XYLink App and register account to get free cloud meeting room.",
    "SIG:491": "",
    "CHARGE:474":
      "Current session is full. \nPlease purchase more cloud meeting ports.",
    "CCC:420":
      "The service number is temporarily unavailable. Please try later.",
    "CHARGE:471":
      "Current session is full. Please use Xiaoyu or cloud meeting room to have multi-party video conference.",
    "CHARGE:472":
      "Call cannot be connected. Xiaoyu Home can only support 4 people in the same call.",
    "CHARGE:477":
      "The meeting is full. Please contact the enterprise administrator to purchase or use the super large cloud conference room.",
    "CCC:421": "The service number is not exist",
    "CHARGE:478": "No sufficient available phone minutes to make calls.",
    "CHARGE:475":
      "Current session is full. Please recharge for your enterprise account or purchase more cloud meeting ports.",
    "CHARGE:476":
      "The meeting is full. Please contact the enterprise administrator to purchase or use the super large cloud conference room.",
    "CCC:404":
      "The service number is temporarily unavailable. Please try later.",
    "CCC:403":
      "The service number is temporarily unavailable. Please try later.",
    "CCC:406": "Parameter is invalid",
    "CCC:405":
      "The service number is temporarily unavailable. Please try later.",
    "CHARGE:469":
      "The usage of service resources has reached the limit, please try again later! ",
    "REC:478":
      "The recording is interrupted, the  Network is connecting, please try again later",
    "CCC:408": "Enterprise is not exist",
    "REC:479":
      "The recording is interrupted, the service is restarting, please try again later",
    "CCC:407": "Enterprise is already exist",
    "CCC:409": "Enterprise Id is invalid",
    "SIG:726": "This number is abnormal and has been restricted. ",
    "SIG:727": "Call is not connected. Please retry.",
    "SIG:724": "You have been forced to join a new meeting",
    "SIG:725": "Call is not connected. Please retry.",
    "REC:470": "No recording server available, please try again later",
    "SIG:722": "Loss of connection between device and pairing terminal",
    "SIG:723": "Loss of connection between device and dispatch service",
    "SIG:720":
      "Please wait a moment, the chairman will invite you to join the conference later.",
    "SIG:721":
      "The conference has not started. Please wait the chairman to join the conference.",
    "CCC:411": "Service number is not exist",
    "CCC:410": "Service number is exist",
    "CHARGE:467":
      "The maximum number of recordings has been reached and you cannot start recording",
    "CCC:413": "Seat is already exist",
    "CHARGE:464":
      "License is needed to start recording, please contact IT administrator to purchase or renewal recording service.",
    "CHARGE:20001":
      "The meeting room has no permission to invite this device to join",
    "CCC:412": "Service number is invalid",
    "CHARGE:20000": "No permission to call this device",
    "CHARGE:459":
      "No sufficient balance in your enterprise account. \nPlease contact IT administrator %s%s to recharge.",
    "CHARGE:457":
      "No sufficient phone minutes. Please recharge or contact IT administrator to enable enterprise account.",
    "CHARGE:458":
      "phone calls are not supported. Please contact IT administrator to enable enterprise account and create enterprise contacts.",
    "SIG:716": "Network unstable, call disconnected.",
    "SIG:713": "Failed to allocated resources for content sharing.",
    "REC:480":
      "Recording failed, because the cloud meeting room single recording mode is enabled",
    "SIG:714": "Failed to allocated resources for content sharing.",
    "REC:481":
      "The recording is interrupted, the  Network is connecting, please try again later",
    "SIG:719": "Call is not connected. Please retry.",
    "SIG:717":
      "The conference has exceeded the maximum call duration limit and switched to voice call mode，could contact the admin to deal with",
    "SIG:718": "Voice call mode restrictions have been lifted",
    "SIG:711": "Content cannot be shared before meeting is started.",
    "SIG:712": "Content cannot be shared before meeting is started.",
    "CHARGE:451": "Your system does not support this type of call.",
    "CHARGE:452":
      "Your cloud meeting room does not support inviting phone calls. \nPlease contact IT administrator to enable enterprise account \nand create enterprise contacts.",
    "CHARGE:450": "Your device does not support this type of call.",
    "CCC:400":
      "The service number is temporarily unavailable. Please try later.",
    "CHARGE:455": "International phone calls are not supported.",
    "CCC:402":
      "The service number is temporarily unavailable. Please try later.",
    "CHARGE:453": "Insufficient.",
    "CCC:401":
      "The service number is temporarily unavailable. Please try later.",
    "CHARGE:454": "Insufficient.",
    "CHARGE:602":
      "The current number of calls has reached the upper limit, and you cannot join",
    "CHARGE:723": "The enterprise has set up user call isolation",
    "CHARGE:603":
      "Current session is full. \nPlease contact IT administrator to enable enterprise account to support more participants. \nCall XiaoYu service 288288 for more information",
    "CHARGE:721": "Incoming calls from Internet links are not allowed!",
    "CHARGE:601":
      "Meeting capacity is over limit. \nPlease contact IT administrator %s%sto purchase more meeting resources.",
    "CHARGE:722": "The enterprise has set up hardware terminal call isolation",
    "CHARGE:606":
      "The current number of meetings has been overrun and will be automatically terminable in 30 minutes. \n please join the address book to support more party meetings.",
    "CHARGE:607": "Your service is not available enough to call.",
    "CHARGE:604":
      "The terminal supports only 4 Party calls at home. The number of calls is now out of line, and will automatically end in 30 minutes.",
    "CHARGE:605": "UNKONWN",
    "SIG:506": "Internal error on the recording server.",
    "SIG:504": "Call is not connected. Please retry.",
    "CHARGE:608": "Current session is full. \nPlease contact IT administrator",
    "SIG:505": "Call is not connected. Please retry.",
    "CHARGE:609":
      "Current session is full. \nPlease contact IT administrator to purchase super-large meeting service",
    "SIG:502": "Call is not connected. Please retry.",
    "SIG:4999": "Sharing content failed.",
    "SIG:503": "Call is not connected. Please retry.",
    "CHARGE:720": "This account has been used",
    "CHARGE:712":
      "The cloud conference room has been set to prohibit monitoring",
    "CHARGE:713":
      "The cloud conference room that the terminal is participating in is set to prohibit monitoring",
    "CHARGE:710": "Don't support pstn outbound calls",
    "CHARGE:711":
      "Call failed. PSTN call is disabled, please contact your enterprise admin!",
    "CHARGE:716": "The user is offline, unable to join the meeting.",
    "CHARGE:717": "The current user has no permission to join",
    "CHARGE:714":
      "Monitoring permission verification timed out, please try again",
    "REC:503":
      "Xiaoyu recording service is not available, please try again later",
    "CHARGE:715": "This number is abnormal and has been restricted.",
    "CHARGE:718": "Far end does not accept calls",
    "CHARGE:719": "This account has been logged into other terminals to join",
    "SURV:580": "Failed to make IPC call.",
    "REC:505":
      "Xiaoyu recording service is not available, please try again later",
    "REC:506": "Live service is not available, please try again later",
    "REC:507":
      "Xiaoyu recording service is not available, please try again later",
    "REC:509":
      "Xiaoyu recording service is not available, please try again later",
    "CHARGE:701":
      "The account balance of your enterprise is insufficient,so you can't initiate a recording. Please contact your administrator to recharge and try again",
    "CHARGE:702":
      "Personal cloud conference room is not available. Please choose another conference room or contact the administrato",
    "CHARGE:700":
      "The enterprise account does enable multi-recording service charge,so you can't initiate a recording. Please contact customer service for opening",
    "CHARGE:705": "Call failed, insufficient H.323 port of your organization",
    "CHARGE:706":
      "Cloud meeting has reached the upper limit of allowed incoming calls",
    "CHARGE:703":
      "Call failed, the capacity of the H323 cluster used by the call is insufficient.",
    "CHARGE:704": "Call failed, insufficient H.323 port of your organization",
    "SIG:408": "Far end no answer. Please retry later.",
    "SIG:405": "Far end device is not online. Please call again later.",
    "CHARGE:707": "Cloud storage of user is full and can no longer record",
    "SIG:409": "Internal message.",
    "SIG:400": "Failed to connect. Please upgrade to laster version.",
    "SIG:403": "Far end network unstable. Call is disconnected.",
    "SIG:404": "Far end is offline.",
    "SIG:401": "Encryption match failed",
    "SIG:402":
      "It is not allowed to turn off the camera in this meeting room. Please turn on camera to join the meeting",
    "SURV:483": "Failed to synchronize meeting information. Please try again",
    "SURV:482": "The invitation failed, please try again",
  },
};

/**
 * SDK错误码，包含C++和前端
 */
export const SDK_ERROR_MAP: TErrorMap = {
  zh_CN: {
    // 90xx 通用错误
    "XYSDK:969001": "成功",
    "XYSDK:969002": "网络错误",
    "XYSDK:969003": "内部状态错误",
    "XYSDK:969004": "人脸识别未开通",
    // 00xx错误码 2023-6/16号从openapi网站copy进来，原因是之前网站记录的错误码在sdk中丢失
    "XYSDK:960006": "域名配置错误，请检查",
    "XYSDK:960028": "接口请求超时，请稍后重试",
    // 10xx rest错误
    "XYSDK:961000": "请求数据为空，请检查",
    "XYSDK:961001": "登录displayName乱码", // v1.0.2版本以下可能出现，请用encodeURI或encodeURIComponent进行编码
    "XYSDK:961006": "无效密码",
    "XYSDK:961011": "密码错误",
    "XYSDK:961012": "无效的账号或密码",
    "XYSDK:961014": "无效的账号",
    "XYSDK:961028": "连续五次输入密码错误, 请稍后重试",
    "XYSDK:961029": "密码错误",
    "XYSDK:961030": "登录频率受限，请稍后重试", // TODO SDKError_TooManyCountCode
    "XYSDK:961043": "无效企业ID",
    "XYSDK:961045": "无效APPKEY",
    "XYSDK:961046": "操作权限被拒绝",
    "XYSDK:961047": "服务错误", // (无法访问服务器)
    "XYSDK:961048": "无法访问服务器",
    // 20xx 初始化错误
    "XYSDK:962001": "无效的账号或密码",
    "XYSDK:962002": "没有登录",
    "XYSDK:962004": "账号不存在",
    "XYSDK:962030": "手机号码错误",
    // 30xx 呼叫错误
    "XYSDK:963001": "云会议室密码不正确，请重试",
    "XYSDK:963002": "无效会议号",
    "XYSDK:963003": "会议异常断开",
    // 39xx 录制服务器错误码
    "XYSDK:963901": "录制参数错误",
    "XYSDK:963902": "没有录制权限",
    "XYSDK:963903": "云会议室不属于任何企业，无法录制",
    "XYSDK:963904": "当前云会议室存储空间已满，不能再发起录制", // 录制的存储空间已满，您无法开始录制
    "XYSDK:963905": "当前云会议室存储空间已满，不能再发起录制", // 云会议室存储空间已满，不能再发起录制
    "XYSDK:963906": "当前云会议室存储空间已满，不能再发起录制", // 所属部门的云会议室存储空间已满，不能再发起录制
    "XYSDK:963907": "当前云会议室存储空间已满，不能再发起录制", // 所属企业的云会议室存储空间已满，不能再发起录制
    // 40xx 被踢原因
    "XYSDK:964000": "多个长连接建立、需要退出重新登录",
    "XYSDK:964001": "另一部设备登录、需要退出重新登录",
    "XYSDK:964003": "无效SK鉴权失败、需要退出重新登录",
    "XYSDK:964010": "账号已停用, 如需恢复请联系管理员", // 密码已重置, 请重新登录
    // user locked
    "XYSDK:964017": "账号已停用, 如需恢复请联系管理员",
    // 41xx 鉴权失败
    "XYSDK:964101": "数据请求超时，请稍后重试",
    "XYSDK:964102": "当前接口暂未开放",
    "XYSDK:964103":
      "该接口的访问需要进行token认证，但是header中没有携带token；或者调用的接口未在api网关进行配置",
    "XYSDK:964104": "Token已过期",
    "XYSDK:964105": "没有操作权限",
    "XYSDK:964106": "网关刷新Token已过期，请重新登录",
    "XYSDK:964107": "请求Body数据内容超过1MB，请检查",
    "XYSDK:964108": "API网关不存在该签名版本，请检查",
    // 50xx 三方登录错误
    "XYSDK:965001": "使用未加密的接口进行操作", // 密码相关的不加密
    "XYSDK:965002": "无效的公钥",
    "XYSDK:965003": "加密协议错误",
    "XYSDK:965004": "网络异常",
    "XYSDK:965005": "externUserId不合法",
    "XYSDK:965006": "authcode不合法",
    "XYSDK:965007": "authcode已过期",
    "XYSDK:965008": "authcode已被使用",
    "XYSDK:965009": "参数不合法",
    "XYSDK:965010": "未知登录类型",
    // 特殊错误
    "XYSDK:960700": "内部错误", // 例如qa52环境没有对接三方
    // 前端自定义错误码
    "XYSDK:960101": "Wrong parameter",
    "XYSDK:960102": "Current is custom model, not support switch layout",
    "XYSDK:960103": "Current is custom model, not support switch page",
    "XYSDK:960104": "Current is custom model, not support update layout size",
    "XYSDK:960105": "Current is custom model, not support force full screen",
    "XYSDK:960106": "Not logged in",
    "XYSDK:960107": "The meeting is connected, please end call",
    "XYSDK:960108": "Recording error, other Term has started recording",
    "XYSDK:960109": "Not support set caption language",
    "XYSDK:960110": "The displayName can be up to 128 characters long",
    "XYSDK:960111": "extUserId can only contain numbers, letters, _ and -, and the length cannot be greater than 50",
    "XYSDK:960112": "Not in call, reject emit message",
    "XYSDK:960113": "Recording error, no recording permission",
    "XYSDK:960114": "Recording error, recording in progress",
    "XYSDK:960115": "Recording error, No recording in progress",
    "XYSDK:960116": "Switch page error, exceeded maximum page number",
    "XYSDK:960117": "Content sharing, not support switch layout",
    "XYSDK:960118": "Unreasonable layout switching",
    "XYSDK:960119": "Not found roster",
    "XYSDK:960120": "Proxies can only be set before logging in",

    "XYSDK:963000":
      "Calling...Please check the result in the callback event call-state",
    "XYSDK:963004":
      "Logining...Please check the result in the callback event login-state",
    "XYSDK:963005": "MeetingId or DisplayName is invalid",
    "XYSDK:963006": "Detected that the image format does not support setting background images",
    "XYSDK:963007": "Path not found",

    // 3.8 c++ sdk新加，后续还会有变动
    "XYSDK:960005": "代理地址解析失败",
    "XYSDK:960081": "录制错误",
    "XYSDK:960084": "密码过期",
    "XYSDK:960093": "无效的网关时间戳",
    "XYSDK:960098": "无效的deviceSn",
    "XYSDK:960100": "非企业用户",
  },
  en_US: {},
  zh_TW: {}
};


export const SDK_ERROR_MAP_V2 = {
  "XYSDK:960000": 'XYSDK:969001',
  "XYSDK:960078": 'XYSDK:963905',
  "XYSDK:960079": 'XYSDK:963906',
  "XYSDK:960080": 'XYSDK:963907',
  "XYSDK:960082": 'XYSDK:961000',
  "XYSDK:960083": 'XYSDK:961001',
  "XYSDK:960087": 'XYSDK:962001',
  "XYSDK:960088": 'XYSDK:961006',
  "XYSDK:960097": 'XYSDK:961012',
  "XYSDK:960113": 'XYSDK:961028',
  "XYSDK:960114": 'XYSDK:961011',
  "XYSDK:960128": 'XYSDK:961043',
  "XYSDK:960129": 'XYSDK:961045',
  "XYSDK:960132": 'XYSDK:961047',
  "XYSDK:960133": 'XYSDK:963903',
  "XYSDK:960134": 'XYSDK:963904',
  "XYSDK:960089": 'XYSDK:963903',
  "XYSDK:960090": 'XYSDK:963904',
  // 
  "XYSDK:960093": 'XYSDK:963903',
  "XYSDK:960095": 'XYSDK:963001',
  "XYSDK:960096": 'XYSDK:961011',
  "XYSDK:960099": 'XYSDK:961014',
  // "XYSDK:960102": 'XYSDK:962030',
  // "XYSDK:960104": 'XYSDK:962030',
  // "XYSDK:960108": 'XYSDK:960084',
  // "XYSDK:960110": 'XYSDK:960084',
  // "XYSDK:960112": 'XYSDK:961030',
  // "XYSDK:960115": 'XYSDK:961028',
  // "XYSDK:960117": 'XYSDK:963905',
  // "XYSDK:960118": 'XYSDK:963906',
  // "XYSDK:960119": 'XYSDK:963907',
  "XYSDK:960127": 'XYSDK:963002',
  "XYSDK:960130": 'XYSDK:963001',
  "XYSDK:960131": 'XYSDK:961046',
  
  // 呼叫错误码
  "XYSDK:961000": 'XYSDK:961043', 
  "XYSDK:961001": 'XYSDK:969002', 
  "XYSDK:961002": 'XYSDK:961047', 
  "XYSDK:961003": 'XYSDK:962002', 
  "XYSDK:961005": 'XYSDK:961029', 
  "XYSDK:961006": 'XYSDK:963002', 
}
